import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelLinkQueryCriteriaClass, LabelLinkCriteriaModelQuery} from '../../../criteria/label-link-query-criteria.model';
import {InventoryLabelLinkContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../../shared/api-response.model';
import {ApiVisa} from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryLabelLinkService extends BaseApiTemplateService<InventoryLabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-label-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-label-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-label-links';
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: LabelLinkQueryCriteriaClass
  ): Promise<ApiResponseModel<InventoryLabelLinkContainerModel>> {
    const buildDocCriteria = new LabelLinkCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<InventoryLabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getPromiseByCriteriaBasic(
    visa: ApiVisa, criteria?: LabelLinkQueryCriteriaClass
  ): Promise<BasicApiResponseModel<InventoryLabelLinkContainerModel>> {
    const buildDocCriteria = new LabelLinkCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<BasicApiResponseModel<InventoryLabelLinkContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }
}
